(function initColoringBook() {
    function renderColoringBookOffer({
        offerAssembly,
        dn,
        tableSelector,
    } = {}) {
        if (window.location.href.indexOf('/pages/') > 1) {
            setupNewColoringBook(offerAssembly, dn);
            return;
        }

        const table = document.querySelector(tableSelector);
        if (!table) return;

        table.classList.add('equal-cols');

        var coloringBookPages = [];
        var submissionPages = [];

        if (offerAssembly) {
            coloringBookPages = offerAssembly.image_files_used_cropped;
            submissionPages = offerAssembly.submission_images_cropped;
            // } else if (gallery) {
            //     const coloringBookGallery = gallery.coloring_book
            //         .filter((img) => img.compress === true)
            //         .sort((a, b) => a.meta.page - b.meta.page);

            //     coloringBookPages = coloringBookGallery.filter((img, index) => index % 2 === 0).map((page) => page.url);

            //     submissionPages = coloringBookGallery.filter((img, index) => index % 2 != 0).map((page) => page.url);
        }

        table.innerHTML = '';

        for (let i = 0; i < coloringBookPages.length; i++) {
            const row = table.insertRow();

            // First image
            const cell1 = row.insertCell();
            const wrapper1 = document.createElement('div');
            wrapper1.style.position = 'relative';
            wrapper1.style.overflow = 'hidden';

            const img1 = document.createElement('img');
            img1.src = coloringBookPages[i];
            img1.style.padding = '5px';
            // img1.style.width = '480px';
            img1.style.height = '100%';
            img1.style.objectFit = 'contain';
            img1.setAttribute('loading', 'lazy');
            img1.oncontextmenu = () => false;

            const overlay1 = document.createElement('div');
            overlay1.style.position = 'absolute';
            overlay1.style.top = '0';
            overlay1.style.left = '0';
            overlay1.style.width = '100%';
            overlay1.style.height = '100%';
            overlay1.style.zIndex = '2';
            overlay1.style.cursor = 'not-allowed';
            overlay1.style.display = 'flex';
            overlay1.style.alignItems = 'center';
            overlay1.style.justifyContent = 'center';

            const watermark1 = document.createElement('div');
            watermark1.innerText = 'The Paw Print';
            watermark1.style.rotate = '-45deg';
            watermark1.style.fontSize = '26px';
            watermark1.style.fontWeight = 'bold';
            watermark1.style.color = 'rgba(0, 0, 0, 0.5)';
            watermark1.style.textTransform = 'uppercase';
            watermark1.style.pointerEvents = 'none';
            watermark1.style.userSelect = 'none';
            overlay1.appendChild(watermark1);

            wrapper1.appendChild(img1);
            wrapper1.appendChild(overlay1);
            cell1.appendChild(wrapper1);

            // Second image (if it exists)
            if (i < submissionPages.length) {
                const cell2 = row.insertCell();
                const wrapper2 = document.createElement('div');
                wrapper2.style.position = 'relative';
                wrapper2.style.overflow = 'hidden';

                const img2 = document.createElement('img');
                img2.src = submissionPages[i];
                img2.style.padding = '5px';
                // img2.style.width = '480px';
                img2.style.height = '100%';
                img2.style.objectFit = 'contain';
                img2.setAttribute('loading', 'lazy');
                img2.oncontextmenu = () => false;

                const overlay2 = document.createElement('div');
                overlay2.style.position = 'absolute';
                overlay2.style.top = '0';
                overlay2.style.left = '0';
                overlay2.style.width = '100%';
                overlay2.style.height = '100%';
                overlay2.style.zIndex = '2';
                overlay2.style.cursor = 'not-allowed';
                overlay2.style.display = 'flex';
                overlay2.style.alignItems = 'center';
                overlay2.style.justifyContent = 'center';

                wrapper2.appendChild(img2);
                wrapper2.appendChild(overlay2);
                cell2.appendChild(wrapper2);
            }
        }

        table.style.display = 'block';

        renderColoringBookGalleryTable(coloringBookPages, submissionPages);
    }

    function renderColoringBookGalleryTable(coloringBookPages, submissionPages) {
        console.log('Rendering Coloring Book Gallery Table (only coloring book pages)');

        const mediaGallery = document.querySelector('.main-product__media-gallery');
        if (!mediaGallery) {
            console.error('Media gallery not found');
            return;
        }

        if (!coloringBookPages || !coloringBookPages.length) {
            console.error('Coloring book gallery data not ready');
            return;
        }

        const table = document.createElement('table');
        table.style.width = '100%';
        table.style.borderSpacing = '0px';
        table.style.borderCollapse = 'separate';

        let row;
        for (let i = 0; i < coloringBookPages.length; i++) {
            if (i % 6 === 0) {
                row = table.insertRow();
            }

            const cell = row.insertCell();
            cell.style.padding = '0px';

            const wrapper = document.createElement('div');
            wrapper.style.position = 'relative';
            wrapper.style.overflow = 'hidden';

            const img = document.createElement('img');
            img.src = coloringBookPages[i];
            img.style.padding = '0px';
            img.style.width = '100%';
            img.style.height = 'auto';
            img.style.objectFit = 'contain';
            img.fetchPriority = 'high';
            img.oncontextmenu = () => false;

            const overlay = document.createElement('div');
            overlay.style.position = 'absolute';
            overlay.style.top = '0';
            overlay.style.left = '0';
            overlay.style.width = '100%';
            overlay.style.height = '100%';
            overlay.style.zIndex = '2';
            overlay.style.cursor = 'not-allowed';
            overlay.style.display = 'flex';
            overlay.style.alignItems = 'center';
            overlay.style.justifyContent = 'center';

            const watermark = document.createElement('div');
            watermark.innerText = 'The Paw Print';
            watermark.style.rotate = '-45deg';
            watermark.style.fontSize = '12px';
            watermark.style.fontWeight = 'bold';
            watermark.style.color = 'rgba(0, 0, 0, 0.5)';
            watermark.style.textTransform = 'uppercase';
            watermark.style.pointerEvents = 'none';
            watermark.style.userSelect = 'none';

            overlay.appendChild(watermark);
            wrapper.appendChild(img);
            wrapper.appendChild(overlay);
            cell.appendChild(wrapper);
        }

        mediaGallery.innerHTML = '';
        mediaGallery.style.textAlign = 'center';
        mediaGallery.appendChild(table);
    }

    function setupNewColoringBook(offerAssembly, dn) {
        const imageRow = document.querySelector('.image-comparisons-row');

        const mainImages = document.querySelectorAll('.gp-feature-image-carousel.gp-feature-image-only img');
        const productNameLabel = document.querySelector('.product-name-label h1');
        const leftImages = imageRow && imageRow.querySelectorAll(`img[data-testid="left-image"]`);
        const rightImages = imageRow && imageRow.querySelectorAll(`img[data-testid="right-image"]`);
        const mediaChildDiv = document.querySelector('.gp-feature-image-carousel .gp-relative');
        const loaderDiv = document.querySelector('.gp-feature-image-carousel .loader');

        console.log(offerAssembly);
        console.log(mainImages);
        console.log(leftImages);
        console.log(rightImages);

        if (dn && productNameLabel) {
            productNameLabel.innerHTML = 'Coloring Book ft. ' + dn;
        }

        const thisPetsImage = offerAssembly.image_files_used_cropped.find((img) => img.includes(dogId));
        const thisPetsPageImage = offerAssembly.submission_images_cropped.find((img) => img.includes(dogId));

        mainImages.forEach((mainImage, index) => {
            if (index > 0 && mainImage.closest('.do-not-personalize')) {
                return;
            }

            mainImage.src = thisPetsImage || (leftImages && leftImages[0]?.src);
            mainImage.setAttribute('srcset', thisPetsImage || (leftImages && leftImages[0]?.src));
            mainImage.style.objectFit = 'contain';
        });

        setTimeout(() => {
            mediaChildDiv.style.display = 'block';
            loaderDiv.remove();
        }, 300);

        if (!imageRow) return;

        leftImages.forEach((lImg, i) => {
            var imgSrc;

            if (i == 0) {
                imgSrc = thisPetsPageImage || (rightImages && rightImages[0]?.src);
            } else {
                imgSrc = offerAssembly.submission_images_cropped.filter((img) => img != thisPetsPageImage)[i];
            }

            lImg.src = imgSrc;
            lImg.setAttribute('srcset', imgSrc);
            lImg.removeAttribute('data-src');
            lImg.removeAttribute('data-srcset');
            lImg.removeAttribute('base-src');
        });

        rightImages.forEach((rImg, i) => {
            var imgSrc;

            if (i == 0) {
                imgSrc = thisPetsImage || (leftImages && leftImages[0]?.src);
            } else {
                imgSrc = offerAssembly.image_files_used_cropped.filter((img) => img != thisPetsImage)[i];
            }

            rImg.src = imgSrc;
            rImg.setAttribute('srcset', imgSrc);
            rImg.removeAttribute('data-src');
            rImg.removeAttribute('data-srcset');
            rImg.removeAttribute('base-src');
        });
    }

    window.renderColoringBookOffer = renderColoringBookOffer;
})();
